const state = {
  media: null,
  medium: null
}

const getters = {
  media: state => state.media,
  medium: state => state.medium
}

const mutations = {
  SET_MEDIA (state, media) {
    state.media = media
  },
  SET_MEDIUM (state, medium) {
    state.medium = medium
  }
}

export default {
  state,
  getters,
  mutations
}
